<template>
  <div class="gettitle">
    <div class="page-heading hidden-sm-and-down">
      <div class="nav-title">
        <h3>{{ getTitle }}</h3>
        <span class="tile-name" v-if="getTypeName">{{ getTypeName }}</span>
        <h4
          v-if="getAdditionalInfo"
          class="title-name"
          v-html="getAdditionalInfo"
        ></h4>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      title: "",
      editRouteNames: ["Cases"],
    };
  },

  mounted() {
    this.title = this.$route.meta.title || "ALL CASES";
  },
  watch: {
    $route(data) {
      this.title = data.meta.title || "ALL CASES";
    },
  },
  computed: {
    getTitle() {
      if (this.$route.path === "/all-orders/active") return "LABSQUIRE ORDERS";
      else if (
        this.$route.path.indexOf("/cases") == 0 &&
        this.getCaseInformation
      ) {
        return (
          "CASE INFO" +
          (this.getCaseInformation && this.getCaseInformation.accession_id
            ? "-" + this.getCaseInformation.accession_id
            : "")
        );
      } else if (this.$route.path === "/billing-cases") {
        return "ALL BILLING CASES";
      } else if (this.$route.path === "/billing-cases/add")
        return "ADD BILLING CASES";
      else if (
        this.$route.path.indexOf("/orders") == 0 &&
        this.getOrderCaseInformation
      ) {
        return (
          "ORDER INFO - " +
          (this.getOrderCaseInformation && this.getOrderCaseInformation.order_id
            ? this.getOrderCaseInformation.order_id
            : "")
        );
      } else if (
        this.$route.name == "Edit-Order-Info" &&
        this.getOrderCaseInformation
      ) {
        return (
          "ORDER INFO - " +
          (this.getOrderCaseInformation && this.getOrderCaseInformation.order_id
            ? this.getOrderCaseInformation.order_id
            : "")
        );
      } else if (
        this.$route.path.indexOf("/result-files") > -1 &&
        this.$route.path.indexOf("/qc-chart") == -1
      ) {
        return "RESULT FILES";
      } else if (this.$route.name === "AuditLogs") {
        return "LOGS";
      } else if (this.$route.name === "PendingCaseView") {
        return "APPROVAL PENDING CASES";
      } else if (this.$route.name === "EditPendingCase") {
        return "APPROVAL PENDING CASES";
      } else if (
        this.$route.path.indexOf("archive") > -1 &&
        this.$route.name != "ArchiveCase" &&
        this.$route.name != "ArchiveOrders" &&
        this.$route.name != "ArchiveEMROrders" &&
        this.$route.name != "ArchiveResults" &&
        this.$route.name != "ArchiveBillingCase"
      ) {
        return "ARCHIVE";
      } else if (
        this.$route.name === "AllReceivedSendOuts" ||
        this.$route.path.indexOf("received-send-outs") > -1
      ) {
        return "RECEIVED SENDOUTS";
      } else if (this.$route.path.indexOf("send-outs") > -1) {
        return "SENDOUTS";
      } else if (this.$route.path.indexOf("labs") > -1) {
        return "LAB DOCUMENTS";
      } else if (this.$route.path.indexOf("toxicology-test-results") > -1) {
        return "TOXICOLOGY";
      } else if (this.$route.meta.title) {
        return this.$route.meta.title;
      } else if (
        this.$route.name == "Case-Information-Update" &&
        this.getCaseInformation
      ) {
        return (
          "CASE INFO" +
          (this.getCaseInformation && this.getCaseInformation.accession_id
            ? "-" + this.getCaseInformation.accession_id
            : "")
        );
      } else return "ALL CASES";
    },
    getTypeName() {
      if (this.editRouteNames.indexOf(this.$route.name) != -1) {
        return "Edit";
      }
      return "";
    },
    getAdditionalInfo() {
      if (
        this.$route.name == "Cases" &&
        this.getCaseInformation &&
        this.getCaseInformation.patient_info &&
        this.getCaseInformation.accession_id
      ) {
        return (
          this.getFullName(this.getCaseInformation.patient_info) +
          "<span>[" +
          this.getCaseInformation.accession_id +
          "]</span>"
        );
      } else if (this.$route.meta.previewTitle) {
        return this.$route.meta.previewTitle;
      }
      return "";
    },
    ...mapGetters({
      getCaseInformation: "cases/getCaseInformation",
    }),
    ...mapGetters("orders", { getOrderCaseInformation: "getCaseInformation" }),
  },
};
</script>

<style lang="scss">
.nav-title {
  display: flex;
  align-items: center;
  .icon {
    align-items: center;
    padding: 0 15px;
    img {
      width: 15px;
    }
  }
  .tile-name {
    color: #363636;
    font-weight: 600;
    padding: 5px 10px;
    font-size: 18px;
  }
  h4 {
    color: #363636;
    font-weight: 600;
    padding: 5px 10px;
    font-size: 18px;
  }
}
</style>
